<template>
    <app-button
        secondary
        :label="what ? $t('edit_what', { what }) : $t('edit')"
    />
</template>

<script setup>
defineProps({ what: String })
</script>
